import { createContext, Dispatch, FormEvent, SetStateAction, useContext } from 'react';
import { Surgerie } from 'types/surgerie';
import { ReportSurgerieQueryParams } from './useFetchReportSurgeries';

export interface ReportSurgerieContextValue {
  anchorEl: HTMLButtonElement | null;
  setAnchorEl: Dispatch<SetStateAction<HTMLButtonElement | null>>;
  filter: ReportSurgerieQueryParams;
  handleChange(index: keyof ReportSurgerieQueryParams, value: any): void;
  handleSearch(e?: FormEvent<HTMLFormElement>): void;
  loading: boolean;
  setSelectedSurgerie: Dispatch<SetStateAction<Surgerie | null>>;
  selectedSurgerie: Surgerie | null;
  surgeries: Surgerie[];
}

const ReportSurgerieContext = createContext<ReportSurgerieContextValue>({} as ReportSurgerieContextValue);
export const ReportSurgerieProvider = ReportSurgerieContext.Provider;
export const ReportSurgerieConsumer = ReportSurgerieContext.Consumer;

export function useReportSurgerie(): ReportSurgerieContextValue {
  const context = useContext(ReportSurgerieContext);
  return context;
}
